import { normalizeFilters } from "../../../shared/lib/normalizeFilters";
import { UserFilters } from "@myapp/contract";

export const userKeys = {
  all: ['users'] as const,

  lists: () => [...userKeys.all, 'list'] as const,

  list: (filters?: UserFilters) =>
    [...userKeys.lists(), normalizeFilters(filters)] as const,

  details: () => [...userKeys.all, 'detail'] as const,

  detail: (id: string) =>
    [...userKeys.details(), id] as const,
}